import { CardQuestion, CardActions } from "./CardPrimitives";
import HairAreaSelector2D from "@/components/intake/hair/HairAreaSelector2D";
import { useIntakeMobileChromeRegistration } from "../IntakeMobileChromeContext";
import type { CardDef } from "../types";

interface HairAreaCardProps {
  card: CardDef;
  value: string[];
  onValue: (v: string[]) => void;
  otherText: string;
  onOtherTextChange: (v: string) => void;
  error?: string;
  onNext: () => void;
  onBack: () => void;
  onSkip?: () => void;
  index: number;
}

export function HairAreaCard({
  card,
  value,
  onValue,
  otherText,
  onOtherTextChange,
  error,
  onNext,
  onBack,
  onSkip,
  index,
}: HairAreaCardProps) {
  // HairAreaSelector2D calls onChange(areaId, isSelected) — we adapt to string[]
  const handleChange = (areaId: string, isSelected: boolean) => {
    if (isSelected) {
      onValue([...value, areaId]);
    } else {
      onValue(value.filter((v) => v !== areaId));
      if (areaId === "other") {
        onOtherTextChange("");
      }
    }
  };

  useIntakeMobileChromeRegistration(
    () => ({
      onContinue: onNext,
      onCancel: onBack,
      onSkip,
    }),
    [onNext, onBack, onSkip],
  );

  return (
    <div>
      <CardQuestion question={card.question} hint={card.hint} index={index} />

      <div className="mx-0 w-full min-w-0 max-w-xl">
        <HairAreaSelector2D
          selectedAreas={value}
          onChange={handleChange}
          otherText={otherText}
          onOtherTextChange={onOtherTextChange}
        />
        {error ? (
          <p className="mt-3 text-sm text-red-600" role="alert">
            {error}
          </p>
        ) : null}
      </div>

      <CardActions onNext={onNext} onBack={onBack} onSkip={onSkip} />
    </div>
  );
}
